// Copyright (c) 2019 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { connect } from "react-redux";
import { Dropdown as BSDrowdown } from "react-bootstrap";

import { isSet } from "utils";
import { IState } from "states/states";
import { IAction } from "actions";

interface IDropdownExtProps {
  caption?: string;
  curItem: string | JSX.Element | undefined;
  items: JSX.Element[];
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

interface IDropdownProps {}

const mapStateToProps = (state: IState) => {
  const props: IDropdownProps = {};
  return props;
};

interface IDropdownDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: IDropdownDispatch = {};
  return dispatchProps;
};

class DropdownComponent extends React.Component<
  IDropdownProps & IDropdownExtProps & IDropdownDispatch
> {
  public render() {
    const className = [this.props.className].join(" ");
    return (
      <BSDrowdown className={`${className} ${this.props.disabled ? "disabled" : ""}`}>
        <BSDrowdown.Toggle
          variant="secondary"
          style={{ marginTop: -2, ...this.props.style }}
          className={this.props.disabled ? "disabled" : undefined}
        >
          {this.props.curItem ? this.props.curItem : this.props.caption}
        </BSDrowdown.Toggle>
        <BSDrowdown.Menu>
          {isSet(this.props.caption) && <BSDrowdown.Item>{this.props.caption}</BSDrowdown.Item>}
          {this.props.items}
        </BSDrowdown.Menu>
      </BSDrowdown>
    );
  }
}

const CustomDropdown = connect(mapStateToProps, mapDispatchToProps)(DropdownComponent);

export default CustomDropdown;
